import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.scss']
})
export class TemplateListComponent {
  public lists: any[] = [];
  public data: any = { status: 1, template: '' };
  public loading = false;
  public loadingTemplate = false;
  public error = '';
  public company_uuid: any;
  public chat_template_uuid: any;
  private loadVersion = 0;

  constructor(private http: HttpService, private router: Router, private activateRoute: ActivatedRoute) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
    this.activateRoute.params.subscribe((v: any) => {
      this.chat_template_uuid = v.template_uuid;
      this.data = { status: 1, template: '' };
      this.error = '';
      const version = ++this.loadVersion;
      this.loadingTemplate = false;
      if (v.template_uuid && v.template_uuid !== 'new') {
        this.init(v.template_uuid, version);
      }
    });
    this.getList();
  }

  statusLabel(status: any): string {
    return ({ 0: 'Inactive', 1: 'Active', 2: 'Settle' } as any)[status] || 'Unknown';
  }

  async getList() {
    const rtn: any = await this.http.post('/admin/chat-template/get-list');
    if (Array.isArray(rtn?.templates)) {
      this.lists = rtn.templates;
    } else {
      this.error = 'Templates could not be loaded. Please refresh and try again.';
    }
  }

  async init(template_uuid: string, version: number) {
    this.loadingTemplate = true;
    try {
      const rtn: any = await this.http.post('/admin/chat-template/get', { template_uuid });
      if (version !== this.loadVersion) return;
      if (!rtn?.uuid) {
        this.error = rtn?.message || 'Template could not be loaded.';
        return;
      }
      this.data = { ...rtn, status: Number(rtn.status) };
    } finally {
      if (version === this.loadVersion) this.loadingTemplate = false;
    }
  }

  async submit() {
    if (this.loading || this.loadingTemplate) return;
    if (!this.data.template?.trim()) {
      this.error = 'Template is required.';
      return;
    }
    this.error = '';
    this.loading = true;
    try {
      const rtn: any = await this.http.post('/admin/chat-template/save', this.data);
      if (!rtn?.status) {
        this.error = rtn?.message || 'Template could not be saved. Please try again.';
        return;
      }
      const uuid = rtn.uuid || rtn.chat_template_uuid || this.data.uuid;
      this.data.uuid = uuid;
      await this.router.navigate(['/lo', this.company_uuid, 'chat-template', uuid]);
      await this.getList();
    } catch {
      this.error = 'Template could not be saved. Please try again.';
    } finally {
      this.loading = false;
    }
  }

  async deleteTemplate() {
    if (this.loading || this.loadingTemplate || !this.data.uuid) return;
    if (!window.confirm('Delete this chat template? It will be removed from the template list and quick replies. Existing chat messages will remain.')) return;
    this.error = '';
    this.loading = true;
    try {
      const rtn: any = await this.http.post('/admin/chat-template/delete', { uuid: this.data.uuid });
      if (!rtn?.status) {
        this.error = rtn?.message || 'Template could not be deleted. Please try again.';
        return;
      }
      await this.router.navigate(['/lo', this.company_uuid, 'chat-template']);
      await this.getList();
    } catch {
      this.error = 'Template could not be deleted. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
